<div class="loading-container" *ngIf="loading">
    <kendo-loader type="converging-spinner" size="large" *ngIf="loading"></kendo-loader>
</div>
<div *ngIf="form" class="layout">
    <div [ngClass]="createExtension ? 'create-extension' : 'review-view-extension'">
        <div class="k-d-inline-flex k-justify-content-between k-w-full">
            <div class="section-heading">
                <h2>
                    {{title}}
                </h2>
            </div>

            <!-- Close button -->
            <button *ngIf="!showHideCloseBtn" kendoButton title="Cancel" aria-label="Cancel" size="large" fillMode="flat" [svgIcon]="xIcon"
                (click)="onCancelSHM()">
            </button>
        </div>

        <form [formGroup]="form">
            <!-- Review Extension -->
            <div>
                <!-- Assessment Name  -->
                <div class="k-mb-6" *ngIf="assessmentName">
                    <p class="secondary-text">Assessment Name</p>
                    <p> {{assessmentName}} </p>
                </div>

                <!-- Evalution Due by Date -->
                <div class="k-mb-6" *ngIf="!showReviewAssessment">
                    <p class="secondary-text">Evaluation Due by Date</p>
                    <p>
                        {{dueDate !== 'Invalid Date' ? dueDate: '' }}
                    </p>
                </div>

                <!-- Review Assessment -->
                <div class="k-mb-6" *ngIf="showReviewAssessment">
                    <div class="k-mb-6">
                        <p class="secondary-text">Review Submitted Date</p>
                        <p>
                            {{date | date:"MM/dd/yyyy"}}
                        </p>
                    </div>

                    <div>
                        <p class="secondary-text">Review Submitted By</p>
                        <p>
                            {{reviewSubmittedDisplayName}}
                        </p>
                    </div>
                </div>


                <!-- Extension Days, Rquested Due by Date, Reason for Extension fields & Additional Information Field -->
                <div class="extension-request-reason-container k-mb-6" *ngIf="!showReviewAssessment">
                    <div class="extension-request-container">
                        <!-- Extension Days Needed field -->
                        <kendo-formfield showError="initial">
                            <kendo-floatinglabel text="Extension Days Needed *">
                                <kendo-dropdownlist [data]="extensionDaysRange" formControlName="extensionDays">
                                </kendo-dropdownlist>
                            </kendo-floatinglabel>
                            <kendo-formerror *ngIf="showExtensionDaysError">
                                Number of Days is Required.
                            </kendo-formerror>
                        </kendo-formfield>

                        <!-- Requested Due by Date field -->
                        <kendo-formfield>
                            <kendo-floatinglabel text="Requested Due by Date">
                                <kendo-datepicker calendarType="classic"
                                    [ngClass]="createExtension === true ? 'extension-fixed-width' : 'fixed-width'"
                                    formControlName="reviewDate" placeholder="MM/DD/YYYY" [format]="format"
                                    [readonly]="true">
                                </kendo-datepicker>
                            </kendo-floatinglabel>
                        </kendo-formfield>
                    </div>

                    <!-- Reason for Extension -->
                    <div>
                        <kendo-formfield>
                            <kendo-floatinglabel text="Reason for Extension *" class="k-w-full">
                                <kendo-dropdownlist [data]="referenceData.reason" [textField]="'description'"
                                    [valueField]="'id'" formControlName="reason"></kendo-dropdownlist>
                            </kendo-floatinglabel>
                            <kendo-formerror>Error: Field is required</kendo-formerror>
                        </kendo-formfield>
                    </div>

                    <!-- Additional Information -->
                    <div *ngIf="showAddInformation">
                        <kendo-formfield showHints="always">
                            <kendo-floatinglabel text="Additional Information *">
                                <kendo-textarea placeholder="Type here" [rows]="3" resizable="vertical"
                                    formControlName="otherReason" #additionalInformation>
                                </kendo-textarea>
                            </kendo-floatinglabel>
                            <kendo-formerror>Error: Field is required</kendo-formerror>
                        </kendo-formfield>
                    </div>

                </div>

                <div class="divider" *ngIf="showApproveOrRejectBtn"></div>

                <!-- Approve or Rejected -->
                <div class="extension-request-reason-container k-mb-6" *ngIf="showApproveOrRejectBtn">
                    <div class="extension-request-container">
                        <kendo-buttongroup [selection]="'single'"
                            [disabled]="this.action === viewAssessment || this.action === view" class="k-w-full">
                            <button kendoButton [toggleable]="true" (click)="getAction('Approve')" class="k-w-full"
                                [ngClass]="{ 'button-highlight': selectedAction === 'Approve' }">Approve
                            </button>
                            <button kendoButton [toggleable]="true" (click)="getAction('Reject')" class="k-w-full"
                                [selected]="selectedAction === 'Reject'"
                                [ngClass]="{ 'button-highlight': selectedAction === 'Reject' }">Reject
                            </button>
                        </kendo-buttongroup>
                    </div>


                    <!-- If User is approving the extension, show Extension days approvied and new due by date fields -->
                    <div class="extension-request-container" *ngIf="showApproveFields  && !showReviewAssessment">
                        <kendo-formfield>
                            <kendo-floatinglabel text="Extension Days Approved *">
                                <kendo-numerictextbox class="k-h-9" formControlName="extensionDaysApproved"
                                    rounded="large" [min]="1" [max]="30" [decimals]="0"
                                    format="##"></kendo-numerictextbox>
                            </kendo-floatinglabel>
                            <kendo-formerror *ngIf="form.get('extensionDaysApproved')?.errors?.required">Error:
                                Field is required</kendo-formerror>
                            <kendo-formerror
                                *ngIf="form.get('extensionDaysApproved')?.errors?.minError || form.get('extensionDaysApproved')?.errors?.maxError">Error:
                                Days should be between 1 to 30</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield>
                            <kendo-floatinglabel text="New Due by Date">
                                <kendo-datepicker calendarType="classic" formControlName="newDueByDate"
                                    placeholder="MM/DD/YYYY" [format]="format" [readonly]="true" #newDueByDate>
                                </kendo-datepicker>
                            </kendo-floatinglabel>
                        </kendo-formfield>
                    </div>

                    <!-- If user rejects the extension, display reason for rejection  -->
                    <div class="extension-request-reason-container" *ngIf="showRejectFields && !showReviewAssessment">
                        <kendo-formfield>
                            <kendo-floatinglabel text="Reason for Rejection *">
                                <kendo-dropdownlist [data]="referenceData.reason" [textField]="'description'"
                                    [valueField]="'id'" formControlName="reasonForRejection" #reasonForRejection>
                                </kendo-dropdownlist>
                            </kendo-floatinglabel>
                            <kendo-formerror>Error: Field is required</kendo-formerror>
                        </kendo-formfield>

                        <!-- If the user selects "other" as the reason for rejection, they must enter in details for the additional information field -->
                        <kendo-formfield *ngIf="showRejectedAddInformation" showHints="always">
                            <kendo-floatinglabel text="Additional Information *">
                                <kendo-textarea placeholder="Type here" [rows]="3" resizable="vertical"
                                    formControlName="otherReasonForRejection" #additionalInformation>
                                </kendo-textarea>
                            </kendo-floatinglabel>
                            <kendo-formerror>Error: Field is required</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>



                <!-- Review Assessment - if user decides to reject the assessment, a reason is needed. If user selects "other" as the reason, additional information is needed -->
                <div class="extension-request-reason-container k-mb-6"
                    *ngIf="showReviewAssementReject || (showReviewAssessment && this.selectedAction === reject)">

                    <kendo-formfield>
                        <kendo-floatinglabel text="Reason for Rejection *">
                            <kendo-dropdownlist [data]="referenceData.reason" [rounded]="'large'"
                                [textField]="'description'" [valueField]="'id'" [size]="'medium'"
                                formControlName="asstmtRejectionReason" #reasonForRejection>
                            </kendo-dropdownlist>
                        </kendo-floatinglabel>
                        <kendo-formerror>Error: Field is required</kendo-formerror>
                    </kendo-formfield>

                    <kendo-formfield showHints="always"
                        *ngIf="form.get('asstmtRejectionReason').value?.id === assessmentRejectionId">
                        <kendo-floatinglabel text="Additional Information *">
                            <kendo-textarea placeholder="Type here" [rows]="3" resizable="vertical"
                                formControlName="asstmtRejectionReasonOther" #additionalInformation>
                            </kendo-textarea>
                        </kendo-floatinglabel>
                        <kendo-formerror>Error: Field is required</kendo-formerror>
                    </kendo-formfield>

                </div>
            </div>
        </form>

        <!-- Close and submit buttons -->
        <div class="page-footer k-text-right">
            <div class="action-btns">
                <button kendoButton themeColor="primary" class="k-w-full"
                    [disabled]="showSubmitBtn || this.form.invalid || loadSaveSpinner || (showApproveOrRejectBtn && !selectedAction) || isStatusFinalised"
                    (click)="submit()" size="medium" rounded="large" fillMode="solid">
                    Submit
                </button>
            </div>
        </div>
    </div>
</div>